const products = [
    {
      "id": 1,
      "name": "Collar Slim",
      "quantity": 0,
      "desc": "½ pulgada de ancho Nombre y 1 numero de tel bordado",
      "price": 1200,
      "img": "https://raknarrok.github.io/static/images/productos/collares/slim.png",
      "category": "collares",
      "available": false
    },
    {
        "id": 2,
        "name": "Collar Normal",
        "quantity": 2,
        "desc": "1 pulgada de ancho Nombre y 1 numero de tel bordado",
        "price": 1500,
        "img": "https://raknarrok.github.io/static/images/productos/collares/normal.png",
        "category": "collares",
        "available": true
    },
    {
        "id": 3,
        "name": "Collar Ancho",
        "quantity": 5,
        "desc": "1 ½ pulgada de ancho Nombre y 1 numero de tel bordado",
        "price": 1800,
        "img": "https://raknarrok.github.io/static/images/productos/collares/ancho.png",
        "category": "collares",
        "available": true
    },
    {
        "id": 4,
        "name": "Collar Coleccion Temporal",
        "quantity": 6,
        "desc": "1 pulgada de ancho Nombre y 1 numero tel bordado",
        "price": 2000,
        "img": "https://raknarrok.github.io/static/images/productos/collares/temporal.png",
        "category": "collares",
        "available": true
    },
    {
        "id": 5,
        "name": "Collar Especial",
        "quantity": 10,
        "desc": "Ancho a tu elección",
        "price": 2000,
        "img": "https://raknarrok.github.io/static/images/productos/collares/especial.png",
        "category": "collares",
        "available": true
    },
    {
        "id": 6,
        "name": "Plaquita Hueso",
        "quantity": 10,
        "desc": "Plaquita de hueso con nombre y numero de tel",
        "price": 1500,
        "img": "https://raknarrok.github.io/static/images/productos/plaquitas/plaquita.png",
        "category": "plaquitas",
        "available": true
    },
    {
        "id": 7,
        "name": "Plaquita Circulo",
        "quantity": 10,
        "desc": "Plaquita de circulo con nombre y numero de tel",
        "price": 1500,
        "img": "https://raknarrok.github.io/static/images/productos/plaquitas/circulo.png",
        "category": "plaquitas",
        "available": true
    },
    {
        "id": 8,
        "name": "Plaquita IFA",
        "quantity": 10,
        "desc": "Plaquita rectangular con detalles de IFA (INE)",
        "price": 1500,
        "img": "https://raknarrok.github.io/static/images/productos/plaquitas/ifa.png",
        "category": "plaquitas",
        "available": true
    },
    {
        "id": 9,
        "name": "Pañal Hembras",
        "quantity": 10,
        "desc": "Pañal para hembras de diferentes tallas",
        "price": 1500,
        "img": "https://raknarrok.github.io/static/images/productos/pampers/hembras.png",
        "category": "pañales",
        "available": true
    },
    {
        "id": 10,
        "name": "Pañal Machos",
        "quantity": 10,
        "desc": "Pañal para machos de diferentes tallas",
        "price": 1500,
        "img": "https://raknarrok.github.io/static/images/productos/pampers/machos.png",
        "category": "pañales",
        "available": true
    },
    {
        "id": 11,
        "name": "Cinturones",
        "quantity": 10,
        "desc": "1 pulgada de ancho Ajustable de 50 a 95 cm Nombre bordado",
        "price": 1500,
        "img": "https://raknarrok.github.io/static/images/productos/cinturones/cinturon.png",
        "category": "cinturones",
        "available": true
    },
    {
        "id": 12,
        "name": "Cinturones Especiales",
        "quantity": 10,
        "desc": "Se hace a la medida, y puedes bordar los datos que tu desees con diferentes tipos de fuentes",
        "price": 1500,
        "img": "https://raknarrok.github.io/static/images/productos/cinturones/cinturonEspecial.png",
        "category": "cinturones",
        "available": true
    },
    {
        "id": 13,
        "name": "Correa Slim",
        "quantity": 10,
        "desc": "½ pulgada de ancho 1.20m de longitud nombre bordado",
        "price": 1500,
        "img": "https://raknarrok.github.io/static/images/productos/correas/correaSlim.png",
        "category": "correas",
        "available": true
    },
    {
        "id": 14,
        "name": "Correa Normal",
        "quantity": 10,
        "desc": "1 pulgada de ancho 1.20m de longitud nombre bordado",
        "price": 1800,
        "img": "https://raknarrok.github.io/static/images/productos/correas/correaNormal.png",
        "category": "correas",
        "available": true
    },
    {
        "id": 15,
        "name": "Correa Ancha",
        "quantity": 10,
        "desc": "1 ½ pulgada de ancho 1.20m de longitud nombre bordado",
        "price": 2000,
        "img": "https://raknarrok.github.io/static/images/productos/correas/correaAncha.png",
        "category": "correas",
        "available": true
    },
    {
        "id": 16,
        "name": "Correa Especial",
        "quantity": 10,
        "desc": "Se hace a la medida, y puedes bordar los datos que tu desees con diferentes tipos de fuente",
        "price": 2500,
        "img": "https://raknarrok.github.io/static/images/productos/correas/correaEspecial.png",
        "category": "correas",
        "available": true
    },
    {
        "id": 17,
        "name": "Spray Dulces Sueños",
        "quantity": 10,
        "desc": "(SPRAY 60 mL) Auxiliar en el tratamiento de insomnio e hiperactividad nocturna. Terapia Floral, aceites esenciales de lavanda y rosas",
        "price": 1500,
        "img": "https://raknarrok.github.io/static/images/productos/spray/sprayDulcesSue%C3%B1os.png",
        "category": "spray",
        "available": true
    },
    {
        "id": 18,
        "name": "Gotas Pánico",
        "quantity": 10,
        "desc": "(GOTAS 30 mL) Ideal para los casos de fobias a la pirotecnia y/o a las tormentas. Flores de bach: Mimulus, Aspen, Star of Bethelem, Rock Rose, Larchh",
        "price": 1500,
        "img": "https://raknarrok.github.io/static/images/productos/gotas/gotasPanico.png",
        "category": "gotas",
        "available": true
    },
    {
        "id": 19,
        "name": "Gotas Ansiedad",
        "quantity": 10,
        "desc": "(GOTAS 30 mL) Auxiliar en el tratamiento de hiperapego, ansiedad por separación, destrucción de cosas por ansiedad. Flores de bach: Impatients, Clematis, Rock Rose, Cherry Plum, Star of Bethelem",
        "price": 1500,
        "img": "https://raknarrok.github.io/static/images/productos/gotas/gotasAnsiedad.png",
        "category": "gotas",
        "available": true
    },
    {
        "id": 20,
        "name": "Homeaopatia Calmidol",
        "quantity": 10,
        "desc": "(GOTAS 30 mL) Acción sobre el sistema articular. Indicado en afecciones traumáticas, fatiga muscular, episodios de excesos musculares, enfriamientos por humedad o después de haberse mojado, dolores reumáticos, neurálgicas dentales, esguinces. Rhus Tox, árnica y Rhododendron",
        "price": 1500,
        "img": "https://raknarrok.github.io/static/images/productos/homeopatia/homeopatiaCalmidol.png",
        "category": "homeopatia",
        "available": true        
    },
    {
        "id": 21,
        "name": "Homeaopatia Sin Alergias",
        "quantity": 10,
        "desc": "(GOTAS 30 mL) Estimula el sistema inmune. Además, permite luchar contra una predisposición a la faringoamigdalitis. Está indicado en: Alergias , afecciones en piel y Alergias sistema respiratorio. Psorinum Nosode",
        "price": 1500,
        "img": "https://raknarrok.github.io/static/images/productos/homeopatia/homeopatiaSinAlergias.png",
        "category": "homeopatia",
        "available": true
    },
    {
        "id": 22,
        "name": "Homeaopatia Pulmon Feliz",
        "quantity": 10,
        "desc": "(GOTAS 30 ml) Refuerza vías respiratorias. Útil para mascotas con pulmones débiles Está indicado en: Mascotas propensas a Pulmonías y  propensas a infecciones respiratorias. Pulmón 7H, organoterápico",
        "price": 1500,
        "img": "https://raknarrok.github.io/static/images/productos/homeopatia/homeopatiaPulmonFeliz.png",
        "category": "homeopatia",
        "available": true
    },
    {
        "id": 23,
        "name": "Pomada Happy Paws",
        "quantity": 10,
        "desc": "(BÁLSAMO 20 gr)  Bálsamo fabricado con productos naturales para humectar y dar brillo las patitas de la mascota. Tepezcohuite con caléndula",
        "price": 1500,
        "img": "https://raknarrok.github.io/static/images/productos/pomada/pomadaHappyPaws.png",
        "category": "pomada",
        "available": true
    },
    {
        "id": 24,
        "name": "Kit ID",
        "quantity": 10,
        "desc": "Collar + Plaquita",
        "price": 4000,
        "img": "https://raknarrok.github.io/static/images/productos/kits/kitID.png",
        "category": "kits",
        "available": true
    },
    {
        "id": 25,
        "name": "Kit Paseo",
        "quantity": 10,
        "desc": "Collar + Correa",
        "price": 4000,
        "img": "https://raknarrok.github.io/static/images/productos/kits/kitPaseo.png",
        "category": "kits",
        "available": true
    },
    {
        "id": 26,
        "name": "Kit Mipekicha",
        "quantity": 10,
        "desc": "Collar + Correa + Plaquita",
        "price": 5500,
        "img": "https://raknarrok.github.io/static/images/productos/kits/kitMipekicha.png",
        "category": "kits",
        "available": true
    },
    {
        "id": 27,
        "name": "Kit Plus",
        "quantity": 10,
        "desc": "Collar + Correa + Cinturon para carro",
        "price": 6000,
        "img": "https://raknarrok.github.io/static/images/productos/kits/kitPlus.png",
        "category": "kits",
        "available": true
    },
    {
        "id": 28,
        "name": "Kit Cuidado",
        "quantity": 10,
        "desc": "Collar + Correa + Flores Bach",
        "price": 7500,
        "img": "https://raknarrok.github.io/static/images/productos/kits/kitCuidado.png",
        "category": "kits",
        "available": true
    }
]

export const getProducts = () => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(products)
        }, 1000)
    })
}

export const getProductById = (id) => {
    return new Promise ((resolve) => {
        setTimeout(() => {
            resolve(products.find(product => product.id === id))
        }, 100)
    })
}

export const getProductsByCategory = (categoryId) => {
    return new Promise ((resolve) => {
        setTimeout(() => {
            resolve(products.filter(product => product.category.toLowerCase() === categoryId.toLowerCase()))
        }, 100)
    })
}
